<template>
  <v-card :hover="true">
    <form ref="form" xs12>
      <v-flex>
        <v-alert
          v-if="alert"
          :type="alert.type"
          dismissible
          v-model="showAlert"
        >
          {{ alert.message }}
        </v-alert>
      </v-flex>
      <v-text-field
        v-model="newPassword"
        v-validate="passwordRules"
        :error-messages="errors.collect('newPassword')"
        data-vv-name="newPassword"
        ref="newPassword"
        prepend-icon="vpn_key"
        :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
        :type="showNewPassword ? 'text' : 'password'"
        class="input-group--focused"
        @click:append="showNewPassword = !showNewPassword"
        color="primary"
        label="New Password *"
      ></v-text-field>
      <v-text-field
        v-model="confirmPassword"
        v-validate="'required|confirmed:newPassword'"
        :error-messages="errors.collect('confirmPassword')"
        data-vv-name="confirmPassword"
        prepend-icon="vpn_key"
        :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
        :type="showConfirmPassword ? 'text' : 'password'"
        class="input-group--focused"
        @click:append="showConfirmPassword = !showConfirmPassword"
        color="primary"
        label="Confirm New Password *"
      ></v-text-field>
      <v-layout align-start row>
        <v-flex xs2><v-btn flat @click="clear">Clear</v-btn></v-flex>
        <v-flex xs4>
          <v-btn
            :loading="loading"
            class="white--text"
            color="primary"
            type="submit"
            @click="submit"
            depressed
          >
            Save
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    newPassword: "",
    confirmPassword: "",
    showAlert: false,
    showNewPassword: false,
    showConfirmPassword: false,
    passwordRules: {
      required: true,
      min: 8,
      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
    }
  }),
  methods: {
    clear() {
      this.newPassword = "";
      this.confirmPassword = "";
      this.showAlert = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
      this.$refs.form.reset();
      this.$validator.reset();
    },
    submit(event) {
      event.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (!this.loading && valid) {
          this.$store.dispatch("auth/confirmPasswordReset", {
            code: this.$route.query.oobCode,
            newPassword: this.newPassword
          });
        }
      });
    }
  },
  computed: mapState("auth", ["alert", "loading"]),
  watch: {
    alert(value) {
      if (value) {
        this.showAlert = true;
      }
    },
    showAlert(value) {
      if (!value) {
        this.$store.commit("auth/setAlert", null);
      }
    }
  }
};
</script>
